export default __webpack_public_path__ + "static/media/wayabank-white.b8fd6451.svg";